__turbopack_context__.v({
  "className": "archivo_2821c0c8-module__qdR_EG__className",
});
